export default {
    list: {
        title: 'Address Book',
        subtitle: 'Gestisci i tuoi contatti',
        addContact: 'Aggiungi Contatto',
        loading: 'Caricamento rubrica...',
        allRoles: 'Tutti i ruoli',
        searchPlaceholder: 'Cerca per nome, cognome o email...',
        rolePlaceholder: 'Filtra per ruolo',
        description: 'Lista dei contatti nella tua rubrica',
        headers: {
            firstName: 'Nome',
            lastName: 'Cognome',
            company: 'Azienda',
            email: 'Email',
            phone: 'Telefono',
            role: 'Ruolo',
            actions: 'Azioni',
        },
        noContacts: {
            title: 'Nessun contatto trovato',
            message: 'Prova a modificare i filtri di ricerca',
            emptyMessage: 'Inizia aggiungendo il primo contatto',
            addFirst: 'Aggiungi Primo Contatto',
            companyTitle: 'Nessun contatto trovato',
            companyMessage: 'Attualmente non ci sono persone associate a questa azienda',
            clearFilter: 'Cancella Filtro',
        },
        modal: {
            addTitle: 'Aggiungi Contatto',
            editTitle: 'Modifica Contatto',
            fields: {
                firstName: 'Nome',
                firstNamePlaceholder: 'Inserisci il nome',
                lastName: 'Cognome',
                lastNamePlaceholder: 'Inserisci il cognome',
                company: 'Azienda',
                companyPlaceholder: 'Inserisci il nome dell\'azienda',
                email: 'Email',
                emailPlaceholder: 'Inserisci l\'email',
                phone: 'Telefono',
                phonePlaceholder: 'Inserisci il numero di telefono',
                role: 'Ruolo',
                notes: 'Note',
                notesPlaceholder: 'Aggiungi note aggiuntive su questo contatto...',
            },
            cancel: 'Annulla',
            save: 'Salva Modifiche',
            create: 'Aggiungi Contatto',
        },
        confirmDelete: {
            title: 'Conferma eliminazione',
            message: 'Sei sicuro di voler eliminare questo contatto? L\'azione non è reversibile.',
            cancel: 'Annulla',
            delete: 'Elimina',
        },
    },
};
